import React from "react";
import { FaEye } from "react-icons/fa";
import { useState } from "react";
import "./register.css";
import Massage from "../../components/massage/massage";
// import Push from "../components/Push";
import { urlRegister } from "../../components/URLlist/urlList";
import { props } from "../../App";
import { saveConsoleLog } from "../../helpFunction/helpFunction";

const Register = ({ setViews, setSpinner, setMassage }: props) => {
	const [userData, setUserData] = useState({ email: "", email2: "", pin: "", notificationToken: "" });
	const [showPassword, setShowPassword] = useState<"password" | "number">("password");
	const [showPasswordPosition, setShowPasswordPosition] = useState<{ x: number; width: number; y: number; height: number }>({ x: 0, y: 0, width: 0, height: 0 });

	const registerSend = async () => {
		if (userData.email.length > 0 || userData.email2.length > 0) {
			if (userData.email !== userData.email2) {
				setMassage({ text: "Adres EMAIL failure !!! ", type: "err" });
				return;
			}
		} else {
			setMassage({ text: "Adres EMAIL failure !!! ", type: "err" });
			return;
		}
		setSpinner(true);
		try {
			fetch(urlRegister, {
				method: "POST",
				credentials: "include",
				body: JSON.stringify(userData),
				headers: {
					"content-type": "application/json",
				},
			})
				.then((data) => data.json())
				.then((data) => {
					if (data.status === 201) {
						setViews({ login: true, home: false, register: false });
						setMassage({ text: data.msg, type: "ok" });
					} else {
						setMassage({ text: data.msg, type: "err" });
					}
				});
		} catch (err) {
			setMassage({ text: "Try again later ...", type: "err" });
			saveConsoleLog(JSON.stringify(`APKA error z Register, ${err}`));
		} finally {
			setUserData({ email: "", email2: "", notificationToken: "", pin: "" });
			setSpinner(false);
		}
	};

	const registerVisible = () => {
		setViews({ login: true, home: false, register: false });
	};

	return (
		<div className={"registerContainer"}>
			{/* <Push setUserData={setUserData} userData={userData} /> */}
			<div className="DivImage">
				<img className="LogoStyle" alt="logo" srcSet={require("../../assets/adibauBirthdayReminder.png")} />
			</div>

			<div className={"InputView"}>
				<input
					type="email"
					inputMode="email"
					className="TextInput"
					placeholder="Type your EMAIL"
					value={userData.email}
					onChange={(email) => setUserData({ ...userData, email: email.target.value })}
					maxLength={50}
				/>
				<input
					type="email"
					className="TextInput"
					inputMode="email"
					placeholder="Type your EMAIL again"
					value={userData.email2}
					onChange={(email2) => setUserData({ ...userData, email2: email2.target.value })}
					maxLength={50}
				/>

				<input
					type={showPassword}
					pattern="[0-9]*"
					inputMode="numeric"
					className="TextInput password"
					placeholder="Type your new PIN"
					onChange={(pin) => setUserData({ ...userData, pin: pin.target.value })}
					value={userData.pin}
					maxLength={15}
					onFocus={(e) => {
						setShowPasswordPosition({ x: e.target.offsetLeft, width: e.target.offsetWidth, y: e.target.offsetTop, height: e.target.offsetHeight });
					}}
				/>
				<FaEye
					style={{
						position: "absolute",
						display: showPasswordPosition.x ? "block" : "none",
						top: showPasswordPosition.y + showPasswordPosition.height / 2 / 2,
						left: showPasswordPosition.x + showPasswordPosition.width - 25,
					}}
					onClick={() => setShowPassword(showPassword === "number" ? "password" : "number")}
				/>
			</div>
			<div className="New_account_div">
				<div className="New_account" onClick={registerVisible}>
					<p>Log In</p>
				</div>

				<div className="New_account registerBtn" onClick={registerSend}>
					<p>Register</p>
				</div>
			</div>
		</div>
	);
};

export default Register;
